import { createComponent } from '@carvana/merch-components';

export const containerPadding = 'px-2xl md:px-0';

export const containerNegativeMargin = '-mx-2xl md:mx-0';

export const Container = createComponent('div', {
  className:
    'bg-background-default pb-6xl sm:pb-7xl sm:pt-2xl md:px-3xl md:pt-4xl lg:px-4xl'
});

export const FiltersResultsContainer = createComponent('div', {
  className: 'grid md:grid-cols-[292px_1fr] md:gap-3xl lg:gap-4xl'
});

export const Main = createComponent('main', {
  className: 'grid h-fit bg-background-default px-2xl sm:px-3xl md:px-0'
});
